export default __webpack_public_path__ + "static/media/keypad.cd8175f9.svg";